import React, { useState } from "react";
import { ExternalLink } from "lucide-react";
import { getYahooUrl } from "@/lib/yahooFinance";

function getArrow(score) {
  if (score >= 4) return '\u25B2\u25B2';
  if (score >= 1) return '\u25B2';
  if (score === 0) return '\u2014';
  if (score >= -3) return '\u25BC';
  return '\u25BC\u25BC';
}

function getBadgeColors(score) {
  if (score > 0) {
    return {
      bg: 'rgba(34, 197, 94, 0.12)',
      text: '#22c55e',
      border: 'rgba(34, 197, 94, 0.35)',
    };
  }
  if (score < 0) {
    return {
      bg: 'rgba(239, 68, 68, 0.12)',
      text: '#ef4444',
      border: 'rgba(239, 68, 68, 0.35)',
    };
  }
  return {
    bg: '#21262d',
    text: '#8b949e',
    border: '#30363d',
  };
}

const InstrumentBadge = React.memo(function InstrumentBadge({ instrument, onClick, isActive }) {
  const { symbol, score, rationale } = instrument;
  const arrow = getArrow(score);
  const colors = getBadgeColors(score);
  const displayScore = score > 0 ? `+${score}` : `${score}`;
  const [hovered, setHovered] = useState(false);
  const yahooUrl = getYahooUrl(symbol);

  const handleClick = (e) => {
    e.stopPropagation();
    // Shift+click → filter toggle
    if (e.shiftKey && onClick) {
      e.preventDefault();
      onClick();
      return;
    }
    // Regular click → Yahoo Finance (let the <a> handle it)
  };

  return (
    <a
      href={yahooUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="instrument-badge"
      aria-label={`${symbol} ${arrow} ${displayScore}`}
      title={rationale ? `${rationale} — Click to view on Yahoo Finance` : `View ${symbol} on Yahoo Finance`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-mono text-xs transition-all duration-150 cursor-pointer no-underline"
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
        ...(isActive && { boxShadow: '0 0 0 1.5px #4ade80' }),
        textDecoration: 'none',
      }}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="text-[11px]">{arrow}</span>
      <span className="font-medium">{symbol}</span>
      <span className="opacity-80">{displayScore}</span>
      {hovered && (
        <ExternalLink size={9} style={{ color: colors.text, opacity: 0.6 }} />
      )}
    </a>
  );
});

export default InstrumentBadge;
